import { ITypedModel } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Model } from 'utility-ts-orm';

export interface IStcSchedulingConfigModel {
  v3_student_scheduler_flag?: boolean;
}

export type STCSchedulingConfigModel = ITypedModel<IStcSchedulingConfigModel>;
angular.module('data-ng-custom-text').factory(
  'ngStcSchedulingConfigModel',
  () =>
    new Model<IStcSchedulingConfigModel>({
      v3_student_scheduler_flag: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/models/stc_scheduling_config_model.ts